import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import xss from "xss";
import { defineComponent, h } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
const _sfc_main = defineComponent({
  name: "WsHtml",
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    element: {
      type: String,
      default: "span"
    }
  },
  setup(props) {
    return () => {
      const sanitizedHtml = xss(props.modelValue);
      return h(props.element, {
        innerHTML: sanitizedHtml
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsHtml.vue.es.js.map
